import { useEffect, useState } from 'react';
import useWebSocket, { ReadyState, useSocketIO } from 'react-use-websocket';
import { DiscadorContextProviderProps } from '../props';
import { DiscadorContext } from './discadorContext';

import {
  DadosLogarType,
  DadosCampanhaType,
  DadosPausasType,
  DadosChamada3CType
} from '../types';
import {
  dadosAgenteMapper
} from '../mappers';
import {
  AGENT_ENTERED_BREAK,
  AGENT_IDLE,
  AGENT_LEFT_BREAK,
  DADOS_CHAMADA,
  FIM_CHAMADA,
  AGENT_IN_ACW,
  FINISHED_CALL,
  CALL_WAS_ABANDONED,
  AGENT_ENTERED_MANUAL,
  AGENT_LEFT_MANUAL,
  LOGGED_OUT,
  CALL_ANSWERED,
  MANUAL_CALL_ANSWERED,
  AGENT_LOGIN_FAILED,
  CALL_FAILED,
  MANUAL_CALL_QUALIFIED,
  CALL_WAS_ABANDONED_DUE_AMD,
  CALL_WAS_NOT_ANSWERED
} from '../constants';
import { useHibrido } from '../../../context/HibridoContext';
import { apiDiscador } from '../../../services/api';
import { useModal } from '../../../hooks/ModalContext';
// import { io } from 'socket.io-client';

export function DiscadorProvider({ children, socketUrl, user, password }: DiscadorContextProviderProps) {
  // const url = `wss://socket.3c.fluxoti.com/socket.io/?token=${socketUrl}&EIO=4=&transport=websocket`
  const url = "https://socket.3c.fluxoti.com"

  const { readyState, getWebSocket } = useWebSocket(url, {
    onMessage: onMessage,
    heartbeat: true,
    shouldReconnect: (closeEvent) => true,
    reconnectAttempts: 10,
    reconnectInterval: 2000,
    fromSocketIO: true,
    queryParams: {
      token: socketUrl
    },
    share: true
  });

  // const readyState = 1

  // const socket = io(url, {
  //   transports: ['websocket'],
  //   autoConnect: true,
  //   query: {
  //     token: socketUrl
  //   }
  // });

  // socket.on('message', onMessage);

  const { setModal, onClose } = useModal()

  const [dadosLogin, setDadosLogin] = useState<DadosLogarType | null>(null);
  const [dadosChamada, setDadosChamada] = useState<DadosChamada3CType | null>(null);
  const [dadosCampanha, setDadosCampanha] = useState<DadosCampanhaType[] | null>(null)
  const [chamandoDestino, setChamandoDestino] = useState<boolean>(false);
  const [operadorEmPausa, setOperadorEmPausa] = useState(false);
  const [operadorManualState, setOperadorManualState] = useState(false);
  const [agentIsACW, setAgentIsACW] = useState(false)
  const [listaPausas, setListaPausas] = useState<DadosPausasType[] | null>(null)
  const [telefoneChamada, setTelefoneChamada] = useState<string>('')
  const [errorDisc, setErrorDisc] = useState<string>('')
  const { setDadosChamada: setDados } = useHibrido();

  const isLogged = !!dadosLogin;
  const onCall = !!dadosChamada;
  const onRinging = !!chamandoDestino;
  const isConnected = ReadyState.OPEN === readyState;
  const onPause = operadorEmPausa;

  useEffect(() => {
    finalizarSessao()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socketUrl])


  async function onMessage(event: MessageEvent<string>): Promise<void> {
    // const [, dados] = event.data.replace(')', '').split('(');
    const { state, data: dados } = dadosAgenteMapper(event.data)
    switch (state.toLowerCase()) {

      case CALL_ANSWERED:
        setChamandoDestino(false)
        break;

      case MANUAL_CALL_ANSWERED:
        setChamandoDestino(false)
        break;

      case DADOS_CHAMADA:
        onDadosChamada(dados as DadosChamada3CType);
        setDados(dados as DadosChamada3CType);
        break;

      case AGENT_IDLE:
        onClose()
        setAgentIsACW(false)
        setDadosLogin({
          descRetorno: 'retorno',
          idRetorno: 'idRetorno',
          idUsuario: 'idUsuario'
        })
        onDadosDespausar();
        await listarPausas()
        break;

      case AGENT_ENTERED_BREAK:
        onDadosPausar();
        break;

      case AGENT_LEFT_BREAK:
        onDadosDespausar();
        break;

      case AGENT_ENTERED_MANUAL:
        onDadosManual();
        break;

      case CALL_FAILED:
        if (operadorManualState) {
          onClose()
          onDadosFimChamada()
        }
        break
      case MANUAL_CALL_QUALIFIED:
        if (operadorManualState) {
          onClose()
          onDadosFimChamada()
        }
        break


      case AGENT_LEFT_MANUAL:
        onDadosAtivo();
        break;

      case AGENT_IN_ACW:
        setModal('Qualificacao Chamada', 'Qualificacao Chamada', false, false)
        setAgentIsACW(true)
        break

      case FINISHED_CALL:
        if (operadorManualState) {
          onClose()
          onDadosFimChamada()
        }
        break

      case AGENT_LOGIN_FAILED:
        setDadosLogin(null)
        setDadosCampanha([])
        setDadosChamada(null)
        setListaPausas([])
        setOperadorEmPausa(false)
        setOperadorManualState(false)
        break

      case LOGGED_OUT:
        setDadosLogin(null)
        setDadosCampanha([])
        setDadosChamada(null)
        setListaPausas([])
        setOperadorEmPausa(false)
        setOperadorManualState(false)
        break

      case CALL_WAS_ABANDONED:
        onDadosFimChamada();
        break;

      case CALL_WAS_ABANDONED_DUE_AMD:
        onDadosFimChamada();
        break;

      case CALL_WAS_NOT_ANSWERED:
        onDadosFimChamada();
        break;

      case FIM_CHAMADA:
        onDadosFimChamada();
        break;
    }
  }

  function desconectarWS() {
    // getWebSocket()?.close()
  }

  function onDadosFimChamada() {
    setDadosChamada(null);
    setDados({} as DadosChamada3CType)
    setChamandoDestino(false);
    setTelefoneChamada('')
  }

  function onDadosRingando() {
    setChamandoDestino(true);
  }

  function onDadosPausar() {
    setOperadorEmPausa(true);
  }

  function onDadosDespausar() {
    setOperadorEmPausa(false);
  }

  function onDadosManual() {
    setOperadorManualState(true);
  }

  function onDadosAtivo() {
    setOperadorManualState(false);
  }

  function onDadosChamada(data: DadosChamada3CType) {
    setDadosChamada(data);
  }

  function getTelefoneChamada(tel: string) {
    setTelefoneChamada(tel)
  }

  async function iniciarSessao(grupo: string = ''): Promise<void> {
    await apiDiscador.get('agent/campaigns', {
      params: {
        api_token: socketUrl,
      },
    }).then(({ data }) => {
      setDadosCampanha(data?.data)
      setErrorDisc('')
      setModal('Campanha Discador', 'Qualificacao Chamada', false, false)
    })
      .catch(erro => {
        setErrorDisc('Token Discador Inválido ou Inexistente!')
        return
      })
  }

  async function logarSessao(campanha: string): Promise<void> {
    await apiDiscador.post('agent/login', { campaign: campanha }, {
      params: {
        api_token: socketUrl,

      },
    })

  }

  async function listarPausas(): Promise<void> {
    const { data } = await apiDiscador.get(`/agent/work_break_intervals`, {
      params: {
        api_token: socketUrl,
      },
    })
    setListaPausas(data?.data)
  }

  async function iniciarPausa(user: string, pauseId: string, pause: string, group: string = '0'): Promise<void> {
    console.log(pauseId)
    await apiDiscador.post(`/agent/work_break/${pauseId}/enter`, {}, {
      params: {
        api_token: socketUrl,
      },
    })
  }

  async function iniciarChamada(
    usuario: string,
    ddd: string,
    telefone: string,
    grupo: string = '',
    contrato: string = '',
    identificador: string = ''
  ): Promise<void> {
    await apiDiscador.post('agent/manual_call/dial', { phone: `${ddd}${telefone}` }, {
      params: {
        api_token: socketUrl,
      },
    })
    onDadosRingando()
  }

  async function finalizarSessao(grupo: string = ''): Promise<void> {
    await apiDiscador.post('agent/logout', {}, {
      params: {
        api_token: socketUrl,
      },
    })
  }

  async function finalizarChamada(grupo: string = ''): Promise<void> {
    await apiDiscador.post(`/agent/call/${dadosChamada?.call.id}/hangup`, {}, {
      params: {
        api_token: socketUrl,
      },
    })

    onDadosFimChamada();
  }

  async function qualificarChamada(quali: string, call_id: string): Promise<void> {
    await apiDiscador.post(`agent/call/${call_id}/qualify`, { qualification_id: quali }, {
      params: {
        api_token: socketUrl,
      },
    }
    )
    // if (dadosChamada?.call?.call_mode?.toLocaleLowerCase() === 'manual') await apiDiscador.post('agent/manual_call/exit', {}, {
    //   params: {
    //     api_token: socketUrl,
    //   },
    // })
    onDadosFimChamada()
  }

  async function operadorManual(): Promise<void> {
    await apiDiscador.post('agent/manual_call/enter', {}, {
      params: {
        api_token: socketUrl,
      },
    })
    setOperadorManualState(true)
  }

  async function operadorAtivo(): Promise<void> {
    await apiDiscador.post('agent/manual_call/exit', {}, {
      params: {
        api_token: socketUrl,
      },
    })
    setOperadorManualState(false)
  }

  async function finalizarPausa(group: string = '0'): Promise<void> {
    await apiDiscador.post('agent/work_break/exit', {}, {
      params: {
        api_token: socketUrl,
      },
    })

  }



  return (
    <DiscadorContext.Provider
      value={{
        iniciarSessao,
        finalizarChamada,
        finalizarPausa,
        finalizarSessao,
        iniciarChamada,
        iniciarPausa,
        isConnected,
        isLogged,
        onCall,
        onPause,
        onRinging,
        dadosLogin,
        dadosChamada,
        dadosCampanha,
        listaPausas,
        listarPausas,
        qualificarChamada,
        logarSessao,
        operadorAtivo,
        operadorManual,
        operadorManualState,
        getTelefoneChamada,
        telefoneChamada,
        errorDisc,
        agentIsACW,
        desconectarWS
      }}
    >
      {children}
    </DiscadorContext.Provider>
  );
}
